import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, ClipboardList, ScanLine, QrCode, BarChart3, Wallet, Users, User } from 'lucide-react';
import { useBizMode } from '../utils/bizMode';

const USER_TABS = [
  { path: '/',        Icon: LayoutDashboard, label: '工作台' },
  { path: '/request', Icon: ClipboardList,   label: '接量'   },
  { path: '/qrcode',  Icon: QrCode,          label: '获客素材' },
  { path: '/me',      Icon: User,            label: '我的'   },
];

// 后台底部导航。第 3 个“记录”标签随当前业务切换：排五 → OCR 记录，证券 → 证券识别记录（path 在渲染时按业务决定）
const ADMIN_TABS = [
  { key: 'overview',   path: '/admin',            Icon: BarChart3, label: '概览' },
  { key: 'settlement', path: '/admin/settlement', Icon: Wallet,    label: '结算' },
  { key: 'records',    path: null,                Icon: ScanLine,  label: '记录' },
  { key: 'users',      path: '/admin/users',      Icon: Users,     label: '用户' },
  { key: 'me',         path: '/admin/me',         Icon: User,      label: '我的' },
];
export const ADMIN_RECORDS_PATH = { legacy: '/admin/ocr', puzzle: '/admin/puzzle-records' };

export default function TabBar({ mode = 'user' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [biz] = useBizMode();
  const here = location.pathname;
  const tabs = mode === 'admin'
    ? ADMIN_TABS.map(t => (t.key === 'records' ? { ...t, path: ADMIN_RECORDS_PATH[biz] || ADMIN_RECORDS_PATH.legacy } : t))
    : USER_TABS;

  return (
    <div className="tab-bar">
      {tabs.map(tab => {
        // exact match for root paths, prefix match for deeper paths
        // “我的”同时覆盖从它进入的识别记录页（排五 /history、证券 /puzzle/records），底部导航保持高亮在“我的”
        // 后台“记录”标签同时覆盖两个业务的记录页（不管当前选的是哪个业务，人在哪个页面就高亮）
        const isActive = tab.key === 'records'
          ? (here.startsWith('/admin/ocr') || here.startsWith('/admin/images') || here.startsWith('/admin/puzzle-records'))
          : tab.path === '/admin'
          ? here === '/admin'
          : tab.path === '/'
          ? here === '/'
          : tab.path === '/me'
          ? (here.startsWith('/me') || here.startsWith('/history') || here.startsWith('/puzzle'))
          : here.startsWith(tab.path);
        return (
          <div
            key={tab.key || tab.path}
            className={`tab-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <tab.Icon size={22} strokeWidth={isActive ? 2.2 : 1.8} />
            <span>{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
}
